import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import cn from 'classnames'

import { get, noop, isEmpty } from 'lodash'
import update from '@scoir/immutability'
import Icon from '@scoir/components-core/dist/components/Icon'
import ToggleBox from '@scoir/components-core/dist/components/ToggleBox'
import LoadingIndicator from '@scoir/components-core/dist/components/LoadingIndicator'
import ExpandSecondary from '@scoir/brand-icons/dist/ExpandSecondary'

import { actions as userActions } from 'store/user'
import { actions as mapFilterActions } from 'store/map-filters'
import crosshairIcon from 'icons/crosshair.svg'
import getMapLocation from '../../get-map-location.js'
import './SetMapPreference.scss'

export class SetMapPreference extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    preference: PropTypes.object,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    zoom: PropTypes.number,
    alterUser: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
    onAfterGoToDefault: PropTypes.func.isRequired,
  }
  state = {
    open: false,
    loading: false,
  }
  goToDefault() {
    this.setState({ open: false })
    this.props.updateFilters(this.props.preference)
    this.props.onAfterGoToDefault()
  }
  setDefault() {
    this.setState({ loading: true })
    this.props
      .alterUser(
        update(this.props.user, {
          RecruitMapPreference: {
            $set: {
              Latitude: this.props.latitude,
              Longitude: this.props.longitude,
              Zoom: this.props.zoom,
            },
          },
        }),
      )
      .then(() => {
        this.setState({
          open: false,
          loading: false,
        })
      })
      .catch(noop)
  }
  render() {
    const { open, loading } = this.state
    const hasPreference = !isEmpty(this.props.preference)
    return (
      <div className={cn('map-default-view-control-comp', { open })}>
        <button
          className="main-button"
          disabled={loading}
          onClick={() => (hasPreference ? this.goToDefault() : this.setDefault())}
        >
          <div className="icon-indicator">
            {loading ? (
              <Fragment>
                <LoadingIndicator enabled />
                &nbsp;
              </Fragment>
            ) : (
              <Icon def={crosshairIcon} />
            )}
          </div>
          {hasPreference ? 'Go to Default' : 'Set Default'}
        </button>
        {hasPreference && (
          <Fragment>
            <button
              className="dropdown-toggle"
              onClick={() => this.setState({ open: !open })}
            >
              <ExpandSecondary className="arrow-icon" />
            </button>
            <ToggleBox
              className="dropdown-wrapper"
              collapsed={!open}
              animationDurationSeconds={0.25}
            >
              <div className="dropdown-area">
                <button
                  className="dropdown-option-1"
                  disabled={loading}
                  onClick={() => this.setDefault()}
                >
                  Set New Default
                </button>
              </div>
            </ToggleBox>
          </Fragment>
        )}
      </div>
    )
  }
}

export default connect(
  (store) => {
    const user = store.user.record
    const mapFilters = get(store.mapFilters, 'record', {})
    const preference = get(store.user, 'record.RecruitMapPreference')
    const collegeCoords = get(store.college, 'record.Location.coordinates')
    const { latitude, longitude, zoom } = getMapLocation(mapFilters, preference, collegeCoords)
    return {
      latitude,
      longitude,
      zoom,
      preference: user.RecruitMapPreference,
      user,
    }
  },
  {
    alterUser: userActions.alterUser,
    updateFilters: mapFilterActions.updateFilters,
  },
)(SetMapPreference)
